import * as React from 'react';
import {useEffect, useState} from 'react';
import {Card, CardContent} from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {latestPerUoa} from '../../../utils/wia';

interface ISameObjectiveData {
    submissions: any[];
    uoa: string | number
}

// Categorie di domanda 16, raggruppate come da linee guida: 1/3/8, 2/4/5/6, 7/9, 997.
const PROFILES = [
    {
        name: 'Profili socio-educativi (educatori, assistenti sociali, psicologi, etc.)',
        answers: ['Educatori', 'Assistenti sociali', 'Psicologi'],
    },
    {
        name: 'Profili sanitari (infermieri, medici, fisioterapisti, etc.)',
        answers: ['Infermieri', 'Medici di medicina generale', 'Medici specialisti (neurologi, fisiatri, etc.)', 'Fisioterapisti'],
    },
    {
        name: 'Profili assistenziali (OSS/ASA, badanti, etc.)',
        answers: ['OSS/ASA', 'Badanti'],
    },
    {
        name: 'Altri profili',
        answers: ['other'],
    },
];

const answersOf = (submission: any): string[] =>
    Object.keys(submission)
        .filter((key: string) => key.startsWith('question17_'))
        .map((key: string) => submission[key]);

const involves = (submission: any, answers: string[]): boolean =>
    answersOf(submission).some((answer: string) => answers.includes(answer));

const ProjectSameObjective = ({submissions, uoa}: ISameObjectiveData) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [rows, setRows] = useState<any[]>([]);

    const calculateSubmissions = () => {
        const latest = latestPerUoa(submissions);
        const currentSubmission = latest.find((submission: any) => submission.uoa_id === uoa);

        if (!currentSubmission) {
            setRows(PROFILES.map(profile => ({name: profile.name, involvement: 'No', value: 0})));
            setLoading(true);

            return;
        }

        const sameObjective = latest.filter(
            (submission: any) => submission.question4 === currentSubmission.question4
        );

        setRows(PROFILES.map(profile => ({
            name: profile.name,
            involvement: involves(currentSubmission, profile.answers) ? 'Sì' : 'No',
            value: Math.round(
                sameObjective.filter((submission: any) => involves(submission, profile.answers)).length
                / sameObjective.length * 100
            ),
        })));
        setLoading(true);
    };

    useEffect(() => {
        calculateSubmissions();
    }, []);

    return (
        <Card>
            <CardContent>
                {
                    loading && (
                        <TableContainer component={Paper}>
                            <Table sx={{minWidth: 650}} aria-label='simple table'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell></TableCell>
                                        <TableCell>
                                            COINVOLGIMENTO ATTIVITA'
                                        </TableCell>
                                        <TableCell align='right'>
                                            % COINVOLGIMENTO (a confronto con altre attività che hanno la stessa finalità)
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        rows.map((row) => (
                                            <TableRow
                                                key={row.name}
                                                sx={{'&:last-child td, &:last-child th': {border: 0}}}
                                            >
                                                <TableCell>
                                                    {row.name}
                                                </TableCell>
                                                <TableCell>
                                                    {row.involvement}
                                                </TableCell>
                                                <TableCell align='right'>
                                                    {row.value}%
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )
                }
            </CardContent>
        </Card>
    )
}

export default ProjectSameObjective;
